import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-line-chart-line",
    title: "Trading Education",
    desc: "Our flagship Trading Academy offers structured futures trading education for beginners through advanced investors. Programs are available online and in-person at our Nairobi hub, featuring simulation-based training, live webinars, and mentorship.",
    features: ["Beginner-friendly learning pathways", "Simulation-based trading practice", "Live webinars and workshops", "Nairobi in-person sessions", "Ongoing mentorship support"],
    cta: "Explore Trading Academy",
    ctaPath: "/trading-academy",
    img: "/assets/images/site/svc001-800x600.jpg",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Advisory Services",
    desc: "Our advisory team provides personalized financial guidance tailored to the unique needs of diaspora families, entrepreneurs, and investors. We help you navigate cross-border investment landscapes with clarity and confidence.",
    features: ["Personalized investment strategy", "Cross-border financial planning", "Investor readiness assessment", "Portfolio diversification guidance", "Ongoing advisory relationship"],
    cta: "Book a Consultation",
    ctaPath: "/advisory",
    img: "/assets/images/site/svc002-800x600.jpg",
  },
  {
    icon: "ri-building-2-line",
    title: "Family Office Administration",
    desc: "We provide comprehensive family office support for high-net-worth diaspora families seeking to structure, protect, and grow multi-generational wealth. Our team handles governance, reporting, and strategic coordination.",
    features: ["Wealth structuring and governance", "Multi-generational asset management", "Family investment policy development", "Consolidated reporting", "Succession planning support"],
    cta: "Learn More",
    ctaPath: "/contact",
    img: "/assets/images/site/svc003-800x600.jpg",
  },
  {
    icon: "ri-bank-line",
    title: "Private Credit",
    desc: "We connect qualified investors and entrepreneurs to private credit solutions and structured financing opportunities across African and diaspora-connected markets, providing access typically reserved for institutional players.",
    features: ["Access to private credit markets", "Structured financing solutions", "Deal sourcing and evaluation", "Due diligence support", "Investor network introductions"],
    cta: "Inquire Now",
    ctaPath: "/contact",
    img: "/assets/images/site/svc004-800x600.jpg",
  },
  {
    icon: "ri-funds-line",
    title: "Private Equity",
    desc: "Through our curated network of private equity relationships, we provide diaspora investors with co-investment opportunities and access to high-quality deals across African and emerging markets.",
    features: ["Curated PE deal access", "Co-investment opportunities", "African market focus", "Emerging market exposure", "Strategic partner network"],
    cta: "Explore Opportunities",
    ctaPath: "/contact",
    img: "/assets/images/site/svc005-800x600.jpg",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "Educational Resources",
    desc: "Our digital library of webinars, workshops, ebooks, and video content is designed to build financial literacy and investor readiness for the African Diaspora at every stage of their journey.",
    features: ["On-demand webinar library", "Downloadable ebooks and guides", "Workshop recordings", "Financial literacy curriculum", "Investor readiness tools"],
    cta: "Browse Resources",
    ctaPath: "/insights",
    img: "/assets/images/site/svc006-800x600.jpg",
  },
  {
    icon: "ri-user-star-line",
    title: "Workforce Development",
    desc: "We create career pathways and professional development programs that connect talented diaspora professionals to meaningful opportunities in finance, investment, and business across Africa and globally.",
    features: ["Career pathway programs", "Finance industry mentorship", "Professional skills training", "Network access and introductions", "Cross-border placement support"],
    cta: "Get Involved",
    ctaPath: "/contact",
    img: "/assets/images/site/svc007-800x600.jpg",
  },
];

export default function ServicesPage() {
  return (
    <div className="font-['Inter']">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[60vh] min-h-[480px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/assets/images/site/conference1.jpg"
            alt="Harambee Global Ventures services"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#0D1F14]/75" />
        </div>
        <div className="relative z-10 text-center px-6">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
            What We Offer
          </span>
          <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-bold text-white mb-4">
            Our Services
          </h1>
          <p className="text-white/65 text-lg max-w-2xl mx-auto font-light leading-relaxed">
            From foundational trading education to sophisticated family office support, Harambee Global Ventures serves investors at every stage of their wealth-building journey.
          </p>
        </div>
      </section>

      {/* Services */}
      <div>
        {services.map((svc, i) => (
          <section key={svc.title} className={`py-20 px-6 ${i % 2 === 0 ? "bg-white" : "bg-[#F8F6F3]"}`}>
            <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              {/* Image */}
              <div className={`${i % 2 !== 0 ? "lg:order-2" : ""}`}>
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-[380px] object-cover object-top rounded-lg"
                />
              </div>
              {/* Content */}
              <div className={`${i % 2 !== 0 ? "lg:order-1" : ""}`}>
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 mb-5">
                  <i className={`${svc.icon} text-[#1A4D3C] text-xl`} />
                </div>
                <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-bold text-[#2B2D2F] mb-4">{svc.title}</h2>
                <p className="text-[#6B6B6B] text-base leading-relaxed mb-6">{svc.desc}</p>
                <ul className="space-y-2 mb-8">
                  {svc.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm text-[#2B2D2F]">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-line text-[#1A4D3C] text-base" />
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={svc.ctaPath}
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#1A4D3C] text-white text-sm font-medium hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
                >
                  {svc.cta} <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </section>
        ))}
      </div>

      <section className="px-6 pb-8 bg-white">
        <div className="max-w-[1280px] mx-auto rounded-lg border border-[#E8E4DC] bg-[#F8F6F3] p-6 md:p-7">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0">
              <i className="ri-information-line text-[#1A4D3C] text-lg" />
            </div>
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-2">
                Important Service Disclaimer
              </h2>
              <p className="text-[#6B6B6B] text-sm leading-relaxed">
                Harambee Global Ventures provides education-first programming, investor-readiness support, and strategic advisory conversations. References to family office support, private credit, private equity, or co-investment opportunities are for informational planning purposes only, are intended only for qualified parties where applicable, and remain subject to legal, regulatory, compliance, and diligence review.
              </p>
              <p className="text-[#6B6B6B] text-sm leading-relaxed mt-3">
                Nothing on this site constitutes a public offering, solicitation of securities, legal advice, accounting advice, or personalized investment advice.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 bg-[#2B2D2F]">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="font-['Cormorant_Garamond'] text-4xl font-bold text-white mb-4">Not Sure Where to Start?</h2>
          <p className="text-white/60 text-lg mb-8 font-light max-w-xl mx-auto">Book a complimentary discovery call with our team. We will help you identify the right pathway for your goals.</p>
          <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#C9A961] text-[#2B2D2F] font-semibold text-sm hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer">
            Book a Free Consultation <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
